import styled from 'styled-components'

export const FooterContainer = styled.div`
  padding: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-self: flex-start;
  gap: 20px;
`
